import React, { useEffect, useMemo } from 'react';
import Zone from './Zone';
import Wall from './Wall';
import Rack from './Rack';
import Bin from './Bin';
import FrontSection from "./FrontSection";

const Floor = ({
    floor,
    onBinClick,
    selectedBin,
    selectedRack,
    setSelectedRack,
    setLegendData,
    selectedEntity,
    setBinCounts
}) => {
    const { children = [], xco, yco, zco, width, length } = floor;

    const wallHeight = 8;
    const wallThickness = 5;

    const renderedChildren = useMemo(() => {
        return children.map((entity, index) => {
            if (entity.en_name === "Zone" || entity.en_name === "Open Zone") {
                return (
                    <Zone
                        key={entity.id}
                        zone={entity}
                        onBinClick={onBinClick}
                        selectedBin={selectedBin}
                        selectedRack={selectedRack}
                        setSelectedRack={setSelectedRack}
                        setLegendData={setLegendData}
                        selectedEntity={selectedEntity}
                        color={Array.isArray(selectedEntity.color) ? selectedEntity?.color[index] : selectedEntity?.color}
                        opacity={selectedEntity.entity !== null ? (selectedEntity.entity.id === entity.id ? 1 : 0) : 1}
                        setBinCounts={setBinCounts}
                    />
                );
            } else if (entity.en_name === "Rack") {
                return (
                    <Rack
                        key={entity.id}
                        rack={entity}
                        onBinClick={onBinClick}
                        selectedBin={selectedBin}
                        selectedRack={selectedRack}
                        setSelectedRack={setSelectedRack}
                        setLegendData={setLegendData}
                        selectedEntity={selectedEntity}
                        opacity={selectedEntity.entity !== null ? selectedEntity.entity.id === entity.id ? 1 : 0 : 1}
                    />
                );
            } else if (entity.en_name === "Bin") {
                return (
                    <Bin
                        key={entity.id}
                        bin={entity}
                        onBinClick={onBinClick}
                        selectedBin={selectedBin}
                        setLegendData={setLegendData}
                        selectedEntity={selectedEntity}
                        opacity={selectedEntity.entity !== null ? selectedEntity.entity.id === entity.id ? 1 : 0 : 1}
                    />
                );
            }
            return null;
        });
    }, [children, onBinClick, selectedBin, selectedRack, setSelectedRack, setLegendData, selectedEntity, setBinCounts]);

    useEffect(() => {
        setLegendData((prevState => ([...prevState, { name: floor.en_name, color: "lightgray" }])))
    }, [floor.en_name, setLegendData])

    return (
        <>
            <gridHelper
                args={[1, 9, "black", "lightgray"]}
                scale={[width - wallThickness, 0, length - wallThickness]}
                position={[xco, 0, 0]}
            />

            <Wall
                width={width}
                height={wallHeight}
                depth={wallThickness}
                position={[xco, wallHeight / 2, zco - length / 2]}
                setLegendData={setLegendData}
            />
            <Wall
                width={wallThickness}
                height={wallHeight}
                depth={length + wallThickness}
                position={[xco - width / 2, wallHeight / 2, zco ]}
                setLegendData={setLegendData}
            />
            <Wall
                width={wallThickness}
                height={wallHeight}
                depth={length + wallThickness}
                position={[xco + width / 2, wallHeight / 2, zco]}
                setLegendData={setLegendData}
            />
             {/* <Wall
                width={width+ wallThickness}
                height={wallHeight}
                depth={wallThickness}
                position={[xco, wallHeight / 2, zco + (length + wallThickness) / 2]}
                setLegendData={setLegendData}
            /> */}
            
            <FrontSection xco={xco} zco={zco} width={width} floorLength={length} />

            {renderedChildren}
        </>
    );
};

export default Floor;
